import React, { useEffect, useState } from 'react';
import SignUp from '../SignUp';
import { useLocation } from 'react-router-dom';
import Header from '../../components/Header';
import Login from '../Login';

const Referral = () => {
    const [showLogin, setShowLogin] = useState(false);
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const code = queryParams.get("code");
    const [openModal, setopenModal] = useState(false);


    useEffect(() => {
        const logDetails = JSON.parse(localStorage.getItem("logDetails"));

        // if (code !== "" && code === logDetails.token) {
        setShowLogin(true); // Automatically show login modal if not logged in
        // }
    }, [location]);

    return (
        <>
            <div className="chat-container-clospan">
                <Header />
            </div>
            <div>
                <SignUp showModal={showLogin} handleClose={() => setShowLogin(false)} showModalLogin={() => setopenModal(true)} />
                <Login
                    showModal={openModal}
                    setopenModal={setopenModal}
                    handleClose={() => setopenModal(false)}
                />
            </div>
        </>
    );
};

export default Referral;